import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.576 5.576a.6.6 0 0 1 .848 0l6 6a.6.6 0 0 1 0 .848l-6 6a.6.6 0 0 1-.848-.848L16.55 12.6H6a.6.6 0 1 1 0-1.2h10.55l-4.975-4.976a.6.6 0 0 1 0-.848Z"
      clip-rule="evenodd"
    />
  </svg>
`;
